import React, { useCallback } from "react";
import {
  PopoverListItem,
  PopoverListItemTitle,
  PopoverSectionHeader,
} from "../../../../components/mobile/Popover";
import { FormattedMessage } from "react-intl";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { graphql, useFragment } from "react-relay";
import { StorecastAdminPopoverSectionStore_Store$key } from "./__generated__/StorecastAdminPopoverSectionStore_Store.graphql";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const EDIT_LAYOUT_AND_WIDGETS = (
  <FormattedMessage
    defaultMessage="Edit Layout & Widgets"
    description="StorecastMorePopover: Edit Layout & Widgets"
  />
);

export function StorecastAdminPopoverSectionStore(props: {
  onPressStoreAdmin(): void;
  store: StorecastAdminPopoverSectionStore_Store$key;
}) {
  const store = useFragment(
    graphql`
      fragment StorecastAdminPopoverSectionStore_Store on Store {
        id
        name
      }
    `,
    props.store
  );
  const intl_tokens = useIntlTokens();
  return (
    <>
      <PopoverSectionHeader title={store.name} />
      <PopoverListItem leftIcon="store" onPress={props.onPressStoreAdmin}>
        <PopoverListItemTitle>{intl_tokens.Admin}</PopoverListItemTitle>
      </PopoverListItem>
    </>
  );
}

export function StorecastAdminPopoverSectionDashboard(props: {
  dashboard: any;
  closePopover(): void;
  onPressEditLayoutAndWidgets(): void;
  navigation: UserLoggedInNavigatorNavigationProp<"Dashboard">;
}) {
  const { closePopover, onPressEditLayoutAndWidgets, navigation } = props;
  const dashboard = useFragment(
    graphql`
      fragment StorecastAdminPopoverSectionDashboard_Dashboard on Dashboard {
        id
        name
      }
    `,
    props.dashboard
  );
  const onPressInstallScreen = useCallback(() => {
    closePopover();
    navigation.navigateDeprecated("StoreAdmin", {
      screen: "AddScreen",
      params: {
        fromStorecast: {
          id: dashboard.id,
          name: dashboard.name,
        },
      },
    });
  }, [navigation, closePopover, dashboard]);
  const onPressSettings = useCallback(() => {
    closePopover();
    navigation.navigateDeprecated("StorecastSettings", {
      storecastId: dashboard.id,
    });
  }, [closePopover, navigation, dashboard.id]);
  return (
    <>
      <PopoverSectionHeader title={`Tavla: ${dashboard.name}`} />
      <PopoverListItem leftIcon="edit" onPress={onPressEditLayoutAndWidgets}>
        <PopoverListItemTitle>{EDIT_LAYOUT_AND_WIDGETS}</PopoverListItemTitle>
      </PopoverListItem>
      <PopoverListItem leftIcon="settings" onPress={onPressSettings}>
        <PopoverListItemTitle>
          <FormattedMessage
            defaultMessage="Settings"
            description="StorecastMorePopover: Settings"
          />
        </PopoverListItemTitle>
      </PopoverListItem>
      <PopoverListItem leftIcon="tv" onPress={onPressInstallScreen}>
        <PopoverListItemTitle>
          <FormattedMessage
            description="StorecastAdminPopover Install Screen List Item Title"
            defaultMessage="Install new screen"
          />
        </PopoverListItemTitle>
      </PopoverListItem>
    </>
  );
}
